import { scaleLinear } from 'd3-scale'
import React from 'react'

import i18n from 'live/services/i18n'

import CircleSVG from '../../CardThumbnail/CircleSVG'
import NsIcon from '../../CardThumbnail/NsIcon'
import SsIcon from '../../CardThumbnail/SsIcon'
import { Container, ValueSpan, Line } from './styles'

const colorsArray = [
    // '#32766a',
    '#2d6f55',
    '#327844',
    '#3c924d',
    '#5fb257',
    '#99c555',
    '#d8de50',
    '#f6ed5c',
    '#ea983e',
    '#dd4e41'
]

const ColorScale = scaleLinear().domain([0, 10, 20, 30, 40, 50, 60, 70, 80, 90]).range(colorsArray.reverse())

const ThumbnailCard = ({ event }) => {
    return (
        <Container>
            <div className="LeftDiv">
                <div className="OperationType">
                    <div className="Label">
                        {i18n('EMERGENCY')}
                        <Line length={100} rotate={45} color={ColorScale(event?.TYPEOPTIONS?.emergency?.percent)} />
                    </div>
                    <div className="Number">
                        <ValueSpan color={ColorScale(event?.TYPEOPTIONS?.emergency?.percent)}>
                            {event?.TYPEOPTIONS?.emergency?.percent || 0}
                        </ValueSpan>
                        %
                    </div>
                    {i18n('active barriers')}
                </div>
                <div className="OperationType">
                    <div className="Label">
                        {i18n('MARITIME')}
                        <Line length={65} rotate={-35} color={ColorScale(event?.TYPEOPTIONS?.maritime?.percent)} />
                    </div>
                    <div className="Number">
                        <ValueSpan color={ColorScale(event?.TYPEOPTIONS?.maritime?.percent)}>
                            {event?.TYPEOPTIONS?.maritime?.percent || 0}
                        </ValueSpan>
                        %
                    </div>
                    {i18n('active barriers')}
                </div>
            </div>
            <div className="CenterDiv">
                <svg width={160} height={150}>
                    <CircleSVG transform={`translate(${13} ${0}) scale(1)`} />
                    {event?.type == 'ship' ? (
                        <NsIcon transform={`translate(${0} ${20})  scale(1)`} />
                    ) : (
                        <SsIcon transform={`translate(${0} ${20})  scale(1)`} />
                    )}
                </svg>
            </div>
            <div className="RightDiv">
                <div className="OperationType">
                    <div className="Label">
                        {i18n('OPERATION')}
                        <Line
                            length={95}
                            rotate={-40}
                            toLeft
                            color={ColorScale(event?.TYPEOPTIONS?.operation?.percent)}
                        />
                    </div>
                    <div className="Number">
                        <ValueSpan color={ColorScale(event?.TYPEOPTIONS?.operation?.percent)}>
                            {event?.TYPEOPTIONS?.operation?.percent || 0}
                        </ValueSpan>
                        %
                    </div>
                    {i18n('active barriers')}
                </div>
                <div className="OperationType">
                    <div className="Label">
                        {i18n('DRILLING')}
                        <Line
                            length={65}
                            rotate={25}
                            toLeft
                            color={ColorScale(event?.TYPEOPTIONS?.drilling?.percent)}
                        />
                    </div>
                    <div className="Number">
                        <ValueSpan color={ColorScale(event?.TYPEOPTIONS?.drilling?.percent)}>
                            {event?.TYPEOPTIONS?.drilling?.percent || 0}
                        </ValueSpan>
                        %
                    </div>
                    {i18n('active barriers')}
                </div>
            </div>
        </Container>
    )
}

export default ThumbnailCard
